export const GAMES_CAROUSEL_RESPONSIVE = {
  // Desktop
  d21: {
    breakpoint: { max: 4000, min: 1680 },
    items: 5,
  },
  d2: {
    breakpoint: { max: 1680, min: 1580 },
    items: 4,
  },
  d12: {
    breakpoint: { max: 1580, min: 1380 },
    items: 3,
  },
  d1: {
    breakpoint: { max: 1380, min: 1300 },
    items: 2,
  },

  // Tablet
  t3: {
    breakpoint: { max: 1299, min: 1020 },
    items: 5,
  },
  t2: {
    breakpoint: { max: 1020, min: 860 },
    items: 4,
  },
  t1: {
    breakpoint: { max: 860, min: 700 },
    items: 3,
  },

  // Mobile
  m2: {
    breakpoint: { max: 700, min: 500 },
    items: 2,
  },
  m1: {
    breakpoint: { max: 500, min: 0 },
    items: 1,
  },
};
